<template>
  <div class="question-view ">
    <FixedFontSizeSelector style="width: 50%;">
    <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="ruleForm.title" :safe="false"/>
      </div>

      <div class="fill-list">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="html" :safe="false"/>
      </div>
    </div>
    </FixedFontSizeSelector>
    <div class="quest-img" @click="$emit('urlToParent', ruleForm.img_url)" v-if="ruleForm.img_url">
      <img :src="ruleForm.img_url" :style="imgStyle" alt="">
    </div>

  </div>
</template>

<script>
import EventBus from '../../static/event-bus'
import FixedFontSizeSelector from '@/views/student/components/FontSizeSelector'
import fillSumPlus from '../plugins/fill_sum_plus'
import fillSum from '../plugins/fill_sum'
import {extractOverContent, isStrictJSONString} from '../../plugins/extractOverContent'
import cal from './cal'
import { isPC } from '@/utils/is-rules.js'

const pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'
    , braceLeft = 'LEFTBRACE', braceRight = 'RIGHTBRACE'

let res = cal('16+17--19 - x')
console.log('res', res)
export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    return {
      mathjaxNum: 0,
      html: '',
      imgStyle: null,
      valNum: 0,
      ruleForm: {},

      // 算术等式存储 根据id
      arithmetic: {},
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      // 记录答题次数
      limit: 0
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1 + 1

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 检验填空是否存在非数字内容
    verifyFillExist() {
      let fillDoms = document.querySelectorAll('.fill')

      for(let i = 0; i < fillDoms.length; i++) {
        let node = fillDoms[i]
            ,text = node.value

        if(text.trim() != '' && text != Number(text)) {
          return true
        }
      }

      return false
    },
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)
      this.limit = 0

      // 清除界面数据
      let blocks = document.querySelectorAll('.fill')
      for(let i = 0; i < blocks.length; i++) {
        blocks[i].value = ''
      }

      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.saveAnswers()
    },
    repariRecordQuestion() {
      //console.log(this.recordQuestion)
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    handleRecord(record) {
      //console.log(record)
      let [v] = record.splice(0, 1)
      //console.log(v)
      return v.value
    },
    showTrueFalse() {
      // ////console.clear('-----------')
      let { ruleForm, recordQuestion, form } = this,
          answers = ruleForm.answers,
          inputs = document.querySelectorAll('.fill-box')
      form = JSON.parse(JSON.stringify(form))
      //console.log(recordQuestion)
      if(recordQuestion.length == 0) {
        return ;
      }
      let record = JSON.parse(JSON.stringify(recordQuestion))
      // ////console.clear()

      this.limit = 1
      for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i].querySelector('.fill')
        if(input.classList.contains('arithmetic')) {
          let value = JSON.parse(this.handleRecord(record))
          for(let j in value) {
            if(typeof value[j] === 'object') {
              value[j] = value[j].value
            }
          }
          input.value = value[input.dataset.letter]
        }
      }

      for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i].querySelector('.fill')
        if(input.classList.contains('arithmetic-04')) {
          let value = JSON.parse(this.handleRecord(record))
          for(let j in value) {
            if(typeof value[j] === 'object') {
              value[j] = value[j].value
            }
          }
          input.value = value[input.dataset.letter]
        }
      }

      for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i].querySelector('.fill')
        if(input.classList.contains('arithmetic')
            || input.classList.contains('arithmetic-04')) {
          answers.splice(0, 1)
        }
      }
      for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i].querySelector('.fill')
        if(input.classList.contains('arithmetic')
            || input.classList.contains('arithmetic-04')) {
          continue
        }
        input.value = record.length > 0 ? this.handleRecord(record) : ''

        if(this.mode == 'question') {
          continue ;
        }
        if(recordQuestion[i] != undefined && input.value == answers[0].value) {
          inputs[i].classList.add('determine-success-br')
        } else {
          inputs[i].classList.add('determine-error-br')
        }

        answers.splice(0, 1)
      }

      // 计算等式判断对错
      for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i].querySelector('.fill')
        if(recordQuestion[0].type == 'arithmetic'
            && (input.classList.contains('arithmetic') ||
                input.classList.contains('arithmetic-04'))
        ) {
          let value = JSON.parse(recordQuestion[0].value),
              gs = form.choices[0].value,
              regex = gs.match(/[a-zA-ZⒶ-Ⓩ]/g) || [],
              letters = [],
              // 用户填写的答案
              userAnswers = []
          for(let j in value) {
            if(typeof value[j] == 'object') {
              if(value[j].type != undefined) {
                value[j] = value[j].value
              } else {
                letters.push(j)
                // 如果用户未填答案 为空字符串 为其赋值最小负数
                let n = value[j].value.trim() == '' ? Number.MIN_SAFE_INTEGER : value[j].value
                userAnswers.push(Number(n))
                value[j] = 'x'
              }
            }
          }
          //console.log(regex)
          regex.filter(letter => {
            gs = gs.replace(letter, value[letter])
          })

          //  gs : (8-2)*10=60
          let dsAnswer = gs.split('='),
              first = null,
              calculates = dsAnswer.filter(its => {
                if(its.indexOf('x') > -1) {
                  return its
                } else first = its
              })
          for(let j = 0; j < calculates.length; j++) {
            // 保留10位有效数字 小数: 9, 负数: 9, 负小数: 8
            let retentionLength = 10
            let rightAnswers = String(cal(`${calculates[j]}-(${first})`))
            // 负数
            if(rightAnswers < 0) {
              if(rightAnswers.length > 10) {
                retentionLength = 9
                // 整数, 小数
                let [zs, xs] = String(rightAnswers).split('.'),
                    xsLeng = retentionLength - zs.length
                xs = Math.round(('0.' + xs) * (10 ** xsLeng)) / (10 ** xsLeng)
                rightAnswers = -(Math.abs(Number(zs)) + Number(xs))
              }
            } else {
              // 正数
              if(rightAnswers.length > 10) {
                retentionLength = 9
                // 整数, 小数
                let [zs, xs] = String(rightAnswers).split('.'),
                    xsLeng = retentionLength - zs.length
                xs = Math.round(('0.' + xs) * (10 ** xsLeng)) / (10 ** xsLeng)
                rightAnswers = Number(zs) + Number(xs)
              }
            }

            if(this.mode == 'question') {
              continue ;
            }
            //console.log('----------------------------999')
            //console.log(inputs[i])
            //console.log(userAnswers[0])
            //console.log(rightAnswers)
            if(userAnswers[0] == Number(rightAnswers)) {
              // 移除userAnswers对比的元素
              inputs[i].classList.add('determine-success-br')
              userAnswers.splice(0, 1)
            } else inputs[i].classList.add('determine-error-br')

          }
          recordQuestion.splice(0, 1)
          form.choices.splice(0, 1)
        }
      }
    },
    getChoices() {
      let [first] = this.ruleForm.choices.splice(0, 1)

      return first && first.id
    },
    strConvertDom(data) {
      let regex = /\$\$([^$]*)\$\$|\$([^$]*)\$/g,
          // regex2 = /(?<!\\left)(?<!\\right)\([^()]*\)/g,
          // regex2 = /\([^()|^\\left(|^\\right)]*\)/g,
          regex2 = /@(.*?)#/g,
          regex3 = /#{2}(.*?)#{2}/g,
          regex4 = /\|(.*?)\|/g,
          regex5 = /(&amp;){2}(.*?)(&amp;){2}/g,
          // regex02 = data.match(regex2),
          regex02
      let matches = data.match(regex2);
      if (matches) {
        regex02 = matches.filter(function(match) {
          return !match.includes('\\left(') && !match.includes('\\right)');
        });
      }
      let regex03 = data.match(regex3),
          regex05 = data.match(regex5),
          regexMap = {
            over: /\$(([^$]*)\\over([^$]*))\$/,
            frac: /\$(([^$]*)\\frac([^$]*))\$/,
            overline: /\$(([^$]*)\\overline([^$]*))\$/,
            dfrac: /\$(([^$]*)\\dfrac([^$]*))\$/,
            overbrace: /\$(([^$]*)\\overbrace([^$]*))\$/,
          }
      this.valNum = 0

      // 复制一份recordQuestion
      let records = JSON.parse(JSON.stringify(this.recordQuestion))
      ////console.clear()

      if(regex05) {
        regex05.filter((its) => {
          let itsCte = its.replaceAll('&amp;&amp;', '')
          try {
            if(regex4.test(itsCte)) {
              let pattern, empty, keys, obj, newCte
              let [expression] = itsCte.match(regex4),
                  content = itsCte.replace(expression, '')

              if(records.length > 0) {
                let defaultKeys = JSON.parse(this.handleRecord(records))
                for(let i in defaultKeys) {
                  if(typeof defaultKeys[i] == 'object') {
                    if(defaultKeys[i].type != undefined) {
                      defaultKeys[i] = defaultKeys[i].value
                    } else {
                      defaultKeys[i] = defaultKeys[i].label
                    }
                  }
                }

                obj = fillSumPlus(content, expression, defaultKeys)
              } else {
                obj = fillSumPlus(content, expression)
              }
              newCte = obj.newCte
              pattern = obj.pattern
              empty = obj.empty
              keys = obj.keys

              let fillEare = newCte.match(/\(([a-zA-ZⒶ-Ⓩ])\)/g)
              if(fillEare) {
                fillEare.filter(item => {
                  let letter = item.replace('(', '').replace(')', '')
                  let echoHtml
                      // 将{} 替换成别的字符 防止下列正则被影响
                      , arithmetic = JSON.stringify(keys).replaceAll('{', braceLeft).replaceAll('}', braceRight)

                  echoHtml = `<span class="fill-box">
                    <input data-letter="${letter}" data-pattern="${pattern}" inputmode="tel" oninput="fillingBlanks(event)" data-arithmetic='${arithmetic}' class="fill ordinary arithmetic" />
                  </span>`
                  newCte = newCte.replace(item, echoHtml)
                })
              }
              data = data.replace(its, `<span class="pattern">${newCte}</span>`)
              this.valNum += empty
            }
          } catch(e) {
            //console.log(e)
          }
        })
      }

      // regex04 必须在regex05之后过滤
      let regex04 = data.match(regex4)
      if(regex04) {
        //console.log('regex04')
        regex04.filter((its) => {
          let pattern, empty, keys, obj
          try {
            if(records.length > 0) {
              let defaultKeys = JSON.parse(this.handleRecord(records))
              for(let i in defaultKeys) {
                if(typeof defaultKeys[i] == 'object') {
                  defaultKeys[i] = defaultKeys[i].label
                }
              }
              obj = fillSum(its, defaultKeys)
            } else {
              obj = fillSum(its)
            }
          } catch(e) {
            //console.log(e)
          }
          pattern = obj.pattern
          empty = obj.empty
          keys = obj.keys
          //console.log(pattern, empty, keys)

          let fillEare = pattern.match(/@([a-zA-ZⒶ-Ⓩ])#/g)

          if(fillEare) {
            fillEare.filter(item => {
              let letter = item.replace('@', '').replace('#', '')
              let echoHtml, arithmetic = JSON.stringify(keys)
              //alert('进来了')
              echoHtml = `<span class="fill-box">
                <input type="text" data-letter="${letter}" data-arithmetic=${arithmetic} class="fill ordinary arithmetic-04" inputmode="tel" oninput="fillingBlanks(event)"/>
                </span>`
              // if(this.mode != 'viewAnswer') {
              // } else {
              //   echoHtml = `<span class="fill-box">
              //     <input type="text" data-letter="${letter}" data-arithmetic=${arithmetic} class="fill ordinary arithmetic" />
              //   </span>`
              // }
              pattern = pattern.replace(item, echoHtml)
            })
          }
          data = data.replace(its, `<span class="pattern">${pattern}</span>`)
          this.valNum += empty
        })
      }

      //console.log(data)
      let regex01 = data.match(regex)

      if(regex01) {
        regex01.filter(its => {
          let frac = its.match(regexMap.frac)
              , overline = its.match(regexMap.overline)
              , overbrace = its.match(regexMap.overbrace)
              , dfrac = its.match(regexMap.dfrac)

          if(dfrac) {
            //console.log(dfrac)
            // 处理數据 判断是否被()括住
            for(let i = 2; i < dfrac.length; i++) {
              // 过滤出@#包裹的内容 将其替换成生僻字 '龘'
              let val = dfrac[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              dfrac[i] = dfrac[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                //console.log(val, '+++++')
                val.filter(its => dfrac[i] = dfrac[i].replace(its, '龘'))
              }
            }

            // otherL, otherR 其他, child 分子, parent 分母
            let [, , otherL, content] = dfrac
                , cte = content.match(/\{([^}]+)\}/g)
                , child = ''
                , parent = ''
                , otherR = content || ''
            //console.log(cte)
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  child = r
                  content = content.replace(its, '')
                } else {
                  parent = r
                  content = content.replace(its, '')
                }
              })
            }

            if(child != '' && parent != '') {
              otherR = content
            } else if(child != '') {
              let [p, ...o] = content.split('')
              parent = parent || p
              otherR = o.join('')
            } else {
              let [c, p, ...o] = content.split('')
              child = child || c
              parent = parent || p
              otherR = o.join('')
            }

            ////console.log(otherL, child, parent, otherR)
            let groups = [otherL, child, parent, otherR]

            for(let g = 0; g < groups.length; g++) {
              let val = groups[g].match(/龘/g)
              if(val) {
                let [prevVal, nextVal] = groups[g].split(val[0])
                groups[g] = {fill: true, val: val, prevVal, nextVal}
              }
              else groups[g] = {fill: false, val: groups[g]}
            }

            let [l, c, p, r] = groups
            ////console.log(l, c, p, r)
            let echoHtml = `
              ${
                l.fill ? `${l.prevVal}<span class="fill-box"><input type="text" class="fill ordinary" inputmode="tel" oninput="fillingBlanks(event)"/></span>${l.nextVal}` : l.val
            }
              <span class="some-as">
                ${ c.fill ?
                `
                    <span class="some-child">
                      <span>${c.prevVal}</span>
                      <span class="fill-box">
                        <input type="text" class="fill numerator" inputmode="tel" oninput="fillingBlanks(event)">
                      </span>
                      <span>${c.nextVal}</span>
                    </span>
                    ` :
                c.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${c.val}</span>` :
                    `<span class="denominator">${c.val}</span>`}
                  <span class="line"></span>
                ${ p.fill ?
                `
                    <span class="some-child">
                      <span>${p.prevVal}</span>
                      <span class="fill-box">
                        <input type="text" class="fill numerator" inputmode="tel" oninput="fillingBlanks(event)">
                      </span>
                      <span>${p.nextVal}</span>
                    </span>
                    ` :
                p.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${p.val}</span>` :
                    `<span class="denominator">${p.val}</span>`}
              </span>
              ${
                r.fill ? `${r.prevVal}<span class="fill-box"><input type="text" class="fill ordinary" inputmode="tel" oninput="fillingBlanks(event)"/></span>${r.nextVal}` : r.val
            }
            `
            data = data.replace(its, echoHtml)
          }

          if(overline) {
            ////console.log(overline)
            // 处理數据 判断是否被()括住
            for(let i = 2; i < overline.length; i++) {
              overline[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              overline[i] = overline[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              ////console.log(val)
            }

            // otherL, otherR 其他, content 内容
            let [, , otherL, content] = overline
                , cte = content.match(/\{([^}]+)\}/g)
                , c = ''
                , otherR = content || ''
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  c = r
                  otherR = otherR.replace(its, '')
                } else {
                  otherR = otherR.replace(its, r)
                }
              })
            } else {
              let [f, ...o] = content.split('')
              c = f || ''
              otherR = o.join('')
            }
            ////console.log(otherR)
            let echoHtml = `
              <span class="overline">
                <span>${otherL}</span>
                <span class="overline-content">${c}</span>
                <span>${otherR}</span>
              </span>
            `
            data = data.replace(its, echoHtml)
          }

          let over = its.match(regexMap.over)
          if(over && !overline && !overbrace) {
            ////console.log(over)
            // 取出匹配的字符 在进一步过滤
            let newOver = extractOverContent(over[1])
                , to_filter = /{([^{}]*)}/
                , overs = []

            if(newOver.length != 0) {
              let grade = newOver[0].split('\\over')
              overs = over[1].split(`{${newOver[0]}}`)
              // ////console.clear()
              for(let i = grade.length - 1; i >= 0; i--) {
                let otem = grade[i]
                    , matchRes = otem.match(to_filter)
                //console.log(matchRes)
                if(matchRes && !isStrictJSONString(matchRes[0])) {
                  otem = otem.replace(matchRes[0], matchRes[1])
                }
                overs.splice(1, 0, otem)
              }
              //console.log('newOver.length != 0')
            } else {
              newOver = over[1].match(to_filter)
              // 判断是否包含\over
              if(newOver && newOver[0].indexOf('\\over') > 0) {
                if(newOver) {
                  overs = over[1].split(newOver[0])
                  overs.splice(1, 0, ...newOver[1].split('\\over'))
                } else {
                  overs = ['', ...over[1].split('\\over'), '']
                }
              } else {
                //console.log(over)
                // ////console.clear()
                overs = ['']
                for(let i = 2; i < over.length; i++) {
                  let otem = over[i]
                      , matchRes = otem.match(to_filter)
                  if(matchRes && !isStrictJSONString(matchRes[0])) {
                    otem = otem.replace(matchRes[0], matchRes[1])
                  }
                  overs.push(otem)
                }
              }
            }
            //console.log(overs)
            // 处理數据 判断是否被()括住
            for(let i = 0; i < overs.length; i++) {
              let val = overs[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              overs[i] = overs[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                let [prevVal, nextVal] = overs[i].split(val[0])
                overs[i] = {fill: true, val: val, prevVal, nextVal}
              }
              else overs[i] = {fill: false, val: overs[i]}
            }

            // child 分子, parent 分母
            let [left, child, parent, right] = overs

            let echoHtml = `
            ${
                left.fill ? `<span class="fill-box"><input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill ordinary" /></span>` : left.val
            }
            <span class="some-as">
              ${ child.fill ?
                `
                  <span class="some-child">
                    <span>${child.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill numerator">
                    </span>
                    <span>${child.nextVal}</span>
                  </span>
                  ` :
                child.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${child.val}</span>` :
                    `<span class="denominator">${child.val}</span>`}
                <span class="line"></span>
              ${ parent.fill ?
                `
                  <span class="some-child">
                    <span>${parent.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill numerator">
                    </span>
                    <span>${parent.nextVal}</span>
                  </span>
                  ` :
                parent.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${parent.val}</span>` :
                    `<span class="denominator">${parent.val}</span>`}
            </span>
            ${
                (right && right.fill) ? `<span class="fill-box"><input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill ordinary" /></span>` : (right ? right.val : '')
            }
            `
            data = data.replace(its, echoHtml)
          }

          if(frac) {
            //console.log(frac)
            // integer 整数部分，fraction 分数部分
            let [, , integer, fraction] = frac
                , fractionRegex = /\{.*?\}/g
                // 取出同时去除首尾的大括号
                , [child, parent] = fraction.match(fractionRegex)
                    .map(s => s.slice(1, -1))
                , other = fraction.replace(`{${child}}{${parent}}`, '')
            let echoData = [integer, child, parent, other]
            //console.log(echoData)
            // 处理數据 判断是否被()括住
            for(let i = 0; i < echoData.length; i++) {
              let val = echoData[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              echoData[i] = echoData[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                let [prevVal, nextVal] = echoData[i].split(val[0])
                echoData[i] = {fill: true, val: val, prevVal, nextVal}
                this.valNum ++
              } else echoData[i] = {fill: false, val: echoData[i]}
            }

            let echoHtml = `
            <span class="mixed-number">
              ${ echoData[0].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[0].prevVal}</span>
                    <input type="text" class="fill mixed">
                    <span>${echoData[0].nextVal}</span>
                  </span>
                  `:
                echoData[0].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[0].val}</span>` :
                    `<span class="mixed">${echoData[0].val}</span>`}
              <span class="some-as">
                ${ echoData[1].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[1].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill numerator">
                    </span>
                    <span>${echoData[1].nextVal}</span>
                  </span>
                  `:
                echoData[1].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[1].val}</span>` :
                    `<span class="numerator">${echoData[1].val}</span>`}
                  <span class="line"></span>
                ${ echoData[2].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[2].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill denominator">
                    </span>
                    <span>${echoData[2].nextVal}</span>
                  </span>
                  ` :
                echoData[2].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[2].val}</span>` :
                    `<span class="denominator">${echoData[2].val}</span>`}
              </span>
            </span>
            ${
                echoData[3].fill ? `<span class="fill-box"><input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill ordinary" /></span>` : echoData[3].val
            }
            `
            data = data.replace(its, echoHtml)
          }
        })
      }
      //console.log(data)

      if(regex02) {
        //console.log('regex02')
        regex02.filter(its => {
          let echoHtml = `<span class="fill-box"><input type="text" inputmode="tel" oninput="fillingBlanks(event)" class="fill ordinary" /></span>`
          data = data.replace(its, echoHtml)
          this.valNum ++
        })
      }

      if(regex03) {
        //console.log('regex03')
        regex03.filter(its => {
          let val = its.replace(/##/g, '')
          let echoHtml = `<span class="fill-box1"><span class="proclaimed">${val}</span></span>`
          data = data.replace(its, echoHtml)
        })
      }

      return data.replaceAll(pLeft, '(').replaceAll(pRight, ')')
          .replaceAll(braceLeft, '{').replaceAll(braceRight, '}')
    },
    saveAnswers() {
      let vals = document.querySelectorAll('.fill'),
          valNum = 0, student_choices = [], recordQuestion= []
      // 先取出所有算数等式
      for(let i = 0; i < vals.length; i++) {
        let arithmetic = JSON.parse(JSON.stringify(this.arithmetic))
        //console.log(JSON.parse(JSON.stringify(arithmetic)))
        if(vals[i].classList.contains('arithmetic')) {
          let input = vals[i],
              value = input.value,
              choice_id = Number(input.dataset.id),
              singleMap = arithmetic[choice_id]
          //console.log('value')
          //console.log(value)
          // 找出答案
          for(let i in singleMap) {
            if(typeof singleMap[i] == 'string') {
              //console.log(`typeof singleMap[i] == 'string'`)
              //console.log(i)
              //console.log(value)
              singleMap[i] = {
                label: singleMap[i],
                value
              }
            }
          }
          recordQuestion.push({choice_id, value: JSON.stringify(singleMap), type: 'arithmetic'})
          // 找出答案
          // ////console.clear()
          //console.log(arithmetic)
          //console.log(singleMap)
          for(let i in singleMap) {
            if(typeof singleMap[i] == 'object') {
              if(singleMap[i].type != undefined) {
                singleMap[i] = Number(singleMap[i].value)
              } else {
                singleMap[i] = value.trim() === '' ? '' : Number(value)
              }
            }
          }

          student_choices.push({choice_id, value: JSON.stringify(singleMap)})
          // valNum++
        }
      }

      // 虽然代码一样 但顺序不能乱
      for(let i = 0; i < vals.length; i++) {
        let arithmetic = JSON.parse(JSON.stringify(this.arithmetic))
        if(vals[i].classList.contains('arithmetic-04')) {
          let input = vals[i],
              value = input.value.trim(),
              choice_id = Number(input.dataset.id),
              singleMap = arithmetic[choice_id]
          //console.log('value')
          //console.log(value)
          // 找出答案
          for(let i in singleMap) {
            if(typeof singleMap[i] == 'string') {
              singleMap[i] = {
                label: singleMap[i],
                value
              }
            }
          }
          recordQuestion.push({choice_id, value: JSON.stringify(singleMap), type: 'arithmetic'})
          // 找出答案
          for(let i in singleMap) {
            if(typeof singleMap[i] == 'object') {
              singleMap[i] = Number(value)
            }
          }

          student_choices.push({choice_id, value: JSON.stringify(singleMap)})
          // valNum++
        }
      }

      for(let i = 0; i < vals.length; i++) {
        if(!vals[i].classList.contains('arithmetic') &&
            !vals[i].classList.contains('arithmetic-04')) {
          let input = vals[i],
              value = input.value.trim(),
              choice_id = Number(input.dataset.id)
          //console.log('value')
          //console.log(value)

          student_choices.push({choice_id, value})
          recordQuestion.push({choice_id, value, type: 'default'})
          // valNum++
        }

        if(vals[i].value.trim() != '') {
          valNum ++
        }
      }
      //console.log(valNum)
      //console.log(student_choices)
      this.answer_results.student_choices = student_choices
      this.recordQuestion = recordQuestion
      if(valNum >= 1) {
        this.$emit('permissions', true)
        this.limit = valNum
      } else {
        this.$emit('permissions', false)
        this.limit = 0
      }

      this.repariRecordQuestion()
    },
    // 当ipad运行时，需要将填空设置为数字输入框
    ipadSetNumber(dom) {
      var userAgent = navigator.userAgent;

      if((userAgent.toLowerCase().indexOf('ipad') > -1) ||
          (userAgent.toLowerCase().indexOf('safari') > -1 &&
              navigator.maxTouchPoints && navigator.maxTouchPoints > 0)) {
        dom.setAttribute('type', 'number')
      }
    },
    initData() {
      //console.log(JSON.parse(JSON.stringify(this.form)))
      this.ruleForm = JSON.parse(JSON.stringify(this.form))

      // this.answer_results = {
      //   id: null,
      //   student_choices: []
      // }
      // this.recordQuestion = []

      let content = JSON.parse(this.ruleForm.content)

      // if(this.mode == 'viewAnswer') {
      setTimeout(() => this.html = this.strConvertDom(content.topic), 500)
      // } else {
      // this.html = this.strConvertDom(content.topic)
      // }
      // setTimeout(() => this.html = this.strConvertDom(content.topic), 200)

      // ////console.clear()
      setTimeout(() => {
        this.showTrueFalse()
        let fillDoms = document.querySelectorAll('.fill')

        //console.log(' ++++++++++++++++ ')
        // 先取出所有算数等式
        for(let i = 0; i < fillDoms.length; i++) {
          let dom = fillDoms[i]
          this.ipadSetNumber(dom)
          if(dom.classList.contains('arithmetic')) {
            let id = this.getChoices()
            let dom = fillDoms[i]
            dom.dataset.id = id
            //console.log(dom)
            let keys = JSON.parse(dom.dataset.arithmetic)
            this.arithmetic[id] = keys
            dom.setAttribute('maxlength', '10')
          }
        }

        for(let i = 0; i < fillDoms.length; i++) {
          let dom = fillDoms[i]
          if(dom.classList.contains('arithmetic-04')) {
            let id = this.getChoices()
            let dom = fillDoms[i]
            dom.dataset.id = id
            let keys = JSON.parse(dom.dataset.arithmetic)
            this.arithmetic[id] = keys
            dom.setAttribute('maxlength', '10')
          }
        }

        for(let i = 0; i < fillDoms.length; i++) {
          let dom = fillDoms[i]
          if(dom.classList.contains('arithmetic') || dom.classList.contains('arithmetic-04')) {
            continue
          }
          let id = this.getChoices()
          dom.dataset.id = id
          dom.setAttribute('maxlength', '10')
          if(dom.innerText == '') {
            dom.insertAdjacentHTML('beforeend', '&nbsp;')
          }
        }

        // for(let i = 0; i < fillDoms.length; i++) {
        //   if(!fillDoms[i].classList.contains('arithmetic')
        //     && !fillDoms[i].classList.contains('arithmetic-04')) {
        //     fillDoms[i].dataset.id = this.getChoices()
        //     fillDoms[i].setAttribute('maxlength', '10')
        //   }
        // }
        //console.log('this.recordQuestion')
        //console.log(this.recordQuestion)
        // if(this.recordQuestion.length == 0)
        this.saveAnswers()
      }, 600)

      let t = null
      window.fillingBlanks = () => {
        EventBus.$emit('nextStatus', false)
        if(t != null) {
          clearTimeout(t)
          t == null
        }

        t = setTimeout(() => {
          EventBus.$emit('nextStatus', true)
          this.saveAnswers()
        }, 500)
      }
    },
    test() {
      fillSum('|a-b=c,a=10~20;b=4~6;c=#|', {a: 12, b: 5, c: '(c)'});
      //console.log(test)
    }
  },
  created() {
    if(isPC()) {
      this.imgStyle = {
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
        margin: 'auto'
      }
    }
    this.initData()
  },
  mounted() {
    // this.$nextTick(() => {
    //   let vals = document.querySelectorAll('.fill')


    //   // listenerScoll(this)
    // })


  }
}
</script>

<style lang="scss" scoped>
@import url('../../static/pubile.scss');

.question-view {
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-color: #fff !important;
  // border-radius: 10px;
  .quest {
    // width: calc(55% - 10px);
    height: 100%;

    .title {
      font-size: 16px;
      color: #333;
    }

    .fill-list {
      width: 100%;
      margin-top: 20px;

      .single {
        height: fit-content;
        display: inline-block;
        margin-bottom: 5px;

        .label {
          // width: 40px;
        }

        .val {
          width: 100px;
          height: 40px;
          border-radius: 10px;

          input[type="text"] {
            width: 100%;
            height: 100%;
            text-align: center;
            padding: 5px;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 700;
            border-radius: 10px;
            background-color: #fcd2ab;
            border: none;
            outline: none;
            box-sizing: border-box;
          }
        }

        .over {
          width: 100px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ffcca4;
          border-radius: 10px;
          .mixed {
            width: 40px;
            height: 40px;
            background-color: #ffcca4;
            padding: 0;
          }
          .mixed-empty {
            width: 1px;
            height: 40px;
            background-color: #ffcca4;
            padding: 0;
            cursor: default;
            border: none;
          }

          .fraction {
            height: 100%;
            width: 45px;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            position: relative;

            .fraction-line {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;
              background-color: #333;
              width: 80%;
              height: 2px;
            }
            .numerator, .denominator {
              text-align: center;
              width: 100%;
              height: 45%;
              background-color: #ffcca4;
              border-radius: 3px;
              padding: 0;
            }
          }
        }
      }
    }
  }

  .quest-img {
  margin-left: 10px;
    max-width: 40%;
    max-height: 500px;
    // flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    aspect-ratio: 833/500;
    img {
      // max-width: 100%;
      // max-height: 100%;
      // width: auto;
      // height: auto;
      width: 100%;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>

<style lang="scss">
.ordinary {
  color: #333;
  // margin: 5px 0;
}
.ordinary.fill, .proclaimed, .arithmetic, .arithmetic-04 {
  border-radius: 10px;
  background-color: #fcd2ab;
  outline: none;
  border: none;
  width: 100px;
  height: 40px;
  text-align: center;
  padding: 5px;
  box-sizing: border-box;
  font-size: 16px;
}
.proclaimed, .arithmetic, .arithmetic-04 {
  line-height: 30px;
}
.pattern {
  display: inline;
}
.fill-box, .fill-box1 {
  //display: inline-block;
  border-radius: 10px;
  margin: 5px 0;
  transform: none !important; /* 禁用 transform */
  display: inline-block !important; /* 改用 block 布局 */
}

.overline {
  display: flex;
  align-items: center;
  margin-top: 5px;

  .overline-content {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #333;
    }
  }
}
.some-as {
  display: inline-block;
  // display: flex;
  flex-wrap: wrap;
  margin: 0 5px;
  position: relative;
  color: #333;
  vertical-align: middle;

  .some-child {
    display: flex;
    justify-content: center;
    align-items: center;
    height: fit-content;
    position: relative;
    height: 50px;
  }

  .line {
    width: inherit;
    min-width: 30px;
    height: 1px;
    background-color: #333;
    display: block;
  }

  .numerator, .denominator {
    // margin: 5px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }

  .numerator.fill, .denominator.fill {
    border-radius: 10px;
    background-color: #fcd2ab;
    outline: none;
    border: none;
    width: 100px;
    height: 40px;
    text-align: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
  }
}

.mixed-number {
  display: inline-flex;
  align-items: center;
  .mixed {
    color: #333;
  }

  .mixed.fill {
    border-radius: 10px;
    background-color: #fcd2ab;
    outline: none;
    border: none;
    width: 100px;
    height: 40px;
    text-align: center;
    padding: 5px;
    color: #333;
    font-size: 16px;
  }
}
</style>